import { ApiService } from './services/ApiService';
import { AppError } from './errors/AppError';
import { ProbeService } from './services/ProbeService';
import { Router } from './router/Router';
import { WordingService } from './services/WordingService';
import { SessionService } from './services/SessionService';

/**
 * App Object.
 */
export class App {
  /**
   * Init the application.
   *
   * @param   {string} stage - The initial stage of the application.
   */
  initApplication(stage) {
    try {
      this.setPolyfill();

      // Init Api Services
      ApiService.init(Eui);

      // Init Probe Services
      ProbeService.init(Eui.probesListMaxSize);
      ProbeService.startTimer();

      // Init Wording Services
      WordingService.setDictionnary(Eui.wordings);

      // Router Init
      Router.init(stage);

      // Init the session Handler
      SessionService.createSessionTimer();
    } catch (error) {
      AppError.showError(error);
    }
  }

  /**
   * Set Polyfill for Application.
   */
  /* istanbul ignore next */
  setPolyfill() {
    const isIE = () => navigator.userAgent.indexOf('MSIE ') > -1 || navigator.userAgent.indexOf('Trident/') > -1;

    const functionRemove = () => {
      for (let i = this.length - 1; i >= 0; i -= 1) {
        if (this[i] && this[i].parentElement) {
          this[i].parentElement.removeChild(this[i]);
        }
      }
    };

    if (isIE()) {
      Element.prototype.remove = function () {
        this.parentElement.removeChild(this);
      };

      NodeList.prototype.remove = functionRemove;
      HTMLCollection.prototype.remove = functionRemove;
    }
  }
}
